// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"955":"4f8ec1e0","982":"e4d97bab"}[chunkId] + ".chunk.js";
};